import { render, staticRenderFns } from "./CallTabs.vue?vue&type=template&id=3fb33d06&"
import script from "./CallTabs.vue?vue&type=script&lang=js&"
export * from "./CallTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports